<template>
    <b-row>
        <div class="col-sm-4 mt-3">
            <label for="" class="form-label">Sucursal</label>
            <select class="form-control form-control-sm" v-model="sucursal">
                <option value="">Seleccionar</option>
                <option value="todos">TODAS</option>
                <option v-for="(item, index) in SUCURSALES_SIN_BODEGA_CENTRAL" :key="index" :value="item.codigo">{{
                    item.nombre }}</option>
            </select>
        </div>
        <div class="col-sm-4 mt-3">
            <label for="" class="form-label">Vendedor</label>
            <select class="form-control form-control-sm" v-model="vendedor">
                <option value="">Seleccionar</option>
                <option value="todos">TODOS</option>
                <option v-for="(item, index) in vendedores__" :key="index" :value="item.id">{{ item.nombre_completo }}
                </option>
            </select>
        </div>
        <div class="col-sm-4 mt-3">
            <label for="" class="form-label">Promocion</label>
            <select class="form-control form-control-sm" v-model="promocion">
                <option value="">Seleccionar</option>
                <option value="todos">TODAS</option>
                <option v-for="(item, index) in PROMOCIONES_FILTRADAS_REPORTE" :key="index" :value="item.codigo">{{
                    item.nombre
                }}
                </option>
            </select>
        </div>
        <div class="col-sm-4 mt-3">
            <label for="" class="form-label">Fecha Inicial</label>
            <input type="date" class="form-control form-control-sm" v-model="fecha_inicial">
        </div>
        <div class="col-sm-4 mt-3">
            <label for="" class="form-label">Fecha Final</label>
            <input type="date" class="form-control form-control-sm" v-model="fecha_final">
        </div>
        <div class="col-sm-4 mt-5">
            <button type="button" class="btn btn-sm btn-outline-dark btn-block"
                @click="obtener_registros">Buscar</button>
        </div>

        <div class="col-sm-12 mt-3">
            <div class="marco_promociones">
                <table class="table table-sm table-striped table-bordered" style="font-size: 13px;">

                    <thead>
                        <tr>
                            <th style="width: 10%;text-align: center;">
                                Fecha
                            </th>
                            <th style="width: 15%;">
                                Sucursal
                            </th>
                            <th style="width: 20%;">
                                Vendedor
                            </th>
                            <th style="width: 35%;">
                                Promocion
                            </th>
                            <th style="width: 10%;text-align: center;">
                                Cantidad
                            </th>
                            <th style="width: 10%;text-align: center;">
                                Total
                            </th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr v-for="(item, index) in registros" :key="index">
                            <td style="text-align: center;">
                                {{ item.fecha_movimiento }}
                            </td>
                            <td>
                                {{ item.nombre_sucursal }}
                            </td>
                            <td>
                                {{ item.nombre_vendedor }}
                            </td>
                            <td>
                                {{ item.nombre_promocion }}
                            </td>
                            <td style="text-align: center;">
                                {{ item.cantidad_ventas }}
                            </td>
                            <td style="text-align: center;">
                                Q{{ item.total_de_ventas.toLocaleString(undefined, {
                                    minimumFractionDigits: 2, maximumFractionDigits: 2
                                }) }}
                            </td>

                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </b-row>
</template>

<script>
    import { minix } from '@/components/functions/alertas';
    import moment from 'moment';
    import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';

    export default {
        name: 'Promociones',
        computed: {
            ...mapState(['sucursales', 'lista_formulas', 'id_empresa_seleccionada', 'vendedores']),
            ...mapGetters(['SUCURSALES_SIN_BODEGA_CENTRAL', 'PROMOCIONES_FILTRADAS_REPORTE'])
        },
        data() {
            return {
                sucursal: '',
                vendedor: '',
                vendedores__: [],
                promocion: '',
                fecha_inicial: moment(Date.now()).format('YYYY-MM-DD'),
                fecha_final: moment(Date.now()).format('YYYY-MM-DD'),
                registros: []
            }
        },
        methods: {
            async obtener_registros() {
                if (this.sucursal == '' || this.vendedor == '' || this.promocion == '') {
                    minix({ icon: 'info', mensaje: 'Seleccione todos los campos', tiempo: 3000 })
                } else {
                    let f = {
                        api: `movimientos-detalles/c/reporte_promociones?fecha_inicial=${this.fecha_inicial}&fecha_final=${this.fecha_final}&sucursal=${this.sucursal}&promocion=${this.promocion}&vendedor=${this.vendedor}&empresa=${this.id_empresa_seleccionada}`
                    }

                    let r = await this.obtener_data(f)

                    if (r.length == 0) {
                        minix({ icon: 'info', mensaje: 'No se encontraron registros', tiempo: 3000 })
                        this.registros = []
                    } else {

                        this.registros = r
                    }

                }
            },
            async obtener_usuarios_por_sucursal() {
                if (this.sucursal != '' && this.sucursal != 'todos') {

                    // let r = await axios.get(`${this.URL_SERVIDOR}/api/users?filters[sucursal_asignada][$eq][0]=${this.sucursal}&filters[empresa][$eq][1]=${this.id_empresa_seleccionada}`, this.TOKEN_FORMATEADO)

                    let f = {
                        api: `sucursales-asignadas/c/usuarios?sucursal=${this.sucursal}&empresa=${this.id_empresa_seleccionada}`
                    }

                    let r = await this.obtener_data(f)

                    if (r.length == 0) {
                        minix({ icon: 'info', mensaje: 'No hay registros', tiempo: 3000 })
                        this.vendedores__ = []
                        this.vendedor = ''
                    } else {
                        this.vendedores__ = r
                    }
                } else {
                    this.vendedores__ = []
                }
            },
            setear_sucursal_origen() {
                // ESTO ES PARA QUE FILTRE LAS PROMOCIONES POR SUCURSAL
                this.set_filtro_sucursal_promociones(parseInt(this.sucursal))
                // this.limpiar_lista()

            },
            ...mapActions(['obtener_data', 'obtener_vendedores']),
            ...mapMutations(['set_filtro_sucursal_promociones'])
        },
        mounted() {
            this.set_filtro_sucursal_promociones('')
            this.obtener_vendedores()
        },
        watch: {
            sucursal() {
                this.registros = []
                this.vendedores__ = []
                this.obtener_usuarios_por_sucursal()
                this.setear_sucursal_origen()
            }
        }
    }
</script>

<style>
    .marco_promociones {
        width: 100%;
        height: calc(100vh - 320px);
        overflow: auto;
    }
</style>